export enum PathEnum {
	richiestaScaduta = "richiesta-scaduta",
	welcome = "welcome",

	onBoarding = "",
	start = "start",
	requirements = "requirements",

	step1 = "step-1",
	creazioneProfilo = "creazione-profilo",
	codiceAttivazione = "codice-attivazione",
	cercaImpresa = "cerca-impresa",

	step2 = "step-2",
	presentaAzienda = "presenta-azienda",
	datiAziendali = "dati-aziendali",
	indirizziContatti = "indirizzi-contatti",
	bilancioImpresa = "bilancio-impresa",
	dettagliSocieta = "dettagli-societa",
	step2Complete = "complete-step-2",

	step3 = "step-3",
	raccontaciDiTe = "raccontaci-di-te",
	anagraficaLR = "anagrafica-lr",
	ulterioriInformazioniLR = "ulteriori-informazioni-lr",
	completeLR = "complete-lr",
	sceltaTitolareEffettivo = "scelta-titolare-effettivo",
	identificazioneTitolareEffettivo = "identificazione-titolare-effettivo",
	anagraficaTE = "anagrafica-te",
	ulterioriInformazioniTE = "ulteriori-informazioni-te",
	verificaIdentitaTE = "verifica-identita-te",
	completeTE = "complete-te",

	step4 = "step-4",
	contoPagamento = "conto-pagamento",
	pos = "pos",
	step4Complete = "complete-step-4",

	step5 = "step-5",
	step6 = "step-6",
	step7 = "step-7",
	processoTerminato = "processo-terminato",

	invitation = "invitation",
	identification = "identification",
	anagraficaInvitation = "anagrafica-invitation",
	ulterioriInformazioniInvitation = "ulteriori-informazioni-invitation",
	verificaIdentitaInvitation = "verifica-identita-invitation",
	identificationComplete = "identification-complete",
	invitationComplete = "complete-invitation",

	reopen = "reopen",
	reopenVerificaIdentitaTE = "documenti-te",
	reopenVerificaIdentitaLR = "documenti-lr",
	reopenDocumentiAziendali = "documenti-aziendali",
	reopenDocumentiPagamenti = "documenti-pagamenti",
	reopenIdentificazione = "identificazione",
	reopenFirma = "firma",
	reopenProcessoTerminato = "processo-terminato-v02",

	webhook = "webhook",
	ripresaPraticanWebhook = "ripresa-pratica",
	identityVerificationWebhook = "identity-verification",

	anagrafica = "anagrafica",
	identificazioneLegaleRappresentante = "identificazione-legale-rappresentante",
	carichePubbliche = "cariche-publiche",
}
